module.exports = __webpack_public_path__ + "static/media/carl746-008.d57592b6.jpg";